import React, { } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const MSPResourcesPageView = ({
  loading, isFetching, orgId
}) => {

  return (
    <span className="mspportal resources-page">

    </span>
  );
};

MSPResourcesPageView.propTypes = {
  loading: PropTypes.bool,
  isFetching: PropTypes.bool,
  orgId: PropTypes.string.isRequired,
};

MSPResourcesPageView.defaultProps = {
  loading: false,
  isFetching: false
};

const mapStateToProps = (state) => {
  return {
  }
};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(MSPResourcesPageView);
